<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">
  Manage Dynamic Image Sets
</mat-toolbar>
<mat-card>
  <table
    mat-table
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="disId">
      <th mat-header-cell *matHeaderCellDef>DisId</th>
      <td mat-cell *matCellDef="let row">{{ row.disId }}</td>
    </ng-container>
    <ng-container matColumnDef="copy">
      <th mat-header-cell *matHeaderCellDef>Copy</th>
      <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="copyDis(row.disId)">Copy</button></td>
    </ng-container>
    <ng-container matColumnDef="rename">
      <th mat-header-cell *matHeaderCellDef>Rename</th>
      <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="renameDis(row.disId)">Rename</button></td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>Delete</th>
      <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="deleteDis(row.disId)">Delete</button></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>
</mat-card>
